import type { ReactNode } from "react";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export type FlatChipProps = {
	label: string;
	backgroundColor: string;
	textColor?: string;
	minWidth?: number;
	leading?: ReactNode;
};

export const FlatChip = ({
	label,
	backgroundColor,
	textColor,
	minWidth,
	leading,
}: FlatChipProps) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap={4}
			paddingHorizontal={8}
			paddingVertical={6}
			borderRadius={theme.roundness * 2}
			backgroundColor={backgroundColor}
			minWidth={minWidth}
		>
			{leading}
			<Text
				variant="labelMedium"
				numberOfLines={1}
				style={textColor ? { color: textColor } : undefined}
			>
				{label}
			</Text>
		</Box>
	);
};
